import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _toConsumableArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";
import _classCallCheck from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/classCallCheck";
import _createClass from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/getPrototypeOf";
import _inherits from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/inherits"; //@ts-check

import React from 'react';
import Snackbar from '@material-ui/core/Snackbar';
import Icon from '../Icon';
import Portal from '../Portal';
import RepositoryUploadSnackbarFile from './RepositoryUploadSnackbarFile';
import Divider from '@material-ui/core/Divider';
/**
 * Get files that doesn't exist on the stack (the files that are uploading right now)
 * @param {File[]} files 
 * @param {[{files: File[]}]} stack 
 */

var getNewUploadFiles = function getNewUploadFiles(files, stack) {
  return files.filter(function (file) {
    return !stack.some(function (level) {
      return level.files.indexOf(file) != -1;
    });
  });
};
/**
 * @extends {React.Component<Props>}
 */


var RepositoryUploadSnackbar =
/*#__PURE__*/
function (_React$Component) {
  _inherits(RepositoryUploadSnackbar, _React$Component);
  /**
   * @param {Readonly<Props>} props
   */


  function RepositoryUploadSnackbar(props) {
    var _this;

    _classCallCheck(this, RepositoryUploadSnackbar);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RepositoryUploadSnackbar).call(this, props));

    _this.renderSnackbarMessage = function () {
      var filesStack = _this.state.stack; // empty stack

      if (filesStack.length == 0) return null;
      return filesStack.map(function (data, stackIdx) {
        var stackEl = null;

        if (data.files instanceof Array) {
          stackEl = data.files.map(function (file, fileIdx) {
            return React.createElement(RepositoryUploadSnackbarFile, {
              key: stackIdx + '-' + fileIdx,
              name: file.name,
              size: file.size,
              uploadStatus: data.status
            });
          });
        } else {
          var file = data.files;
          stackEl = React.createElement(RepositoryUploadSnackbarFile, {
            key: stackIdx + '-0',
            name: file.name,
            size: file.size,
            uploadStatus: data.status
          });
        }

        return React.createElement(React.Fragment, {
          key: stackIdx
        }, stackEl, stackIdx < filesStack.length - 1 && React.createElement(Divider, null));
      });
    };

    _this.onCloseSnackbar = function (e, reason) {
      if (reason === 'clickaway') return;

      if (reason === 'timeout') {
        // remove failed and succeeded status
        var uploadingFiles = _this.state.stack.filter(function (s) {
          return s.status.response == 'uploading';
        });

        _this.setState({
          stack: uploadingFiles
        });

        return;
      }

      _this.setState({
        stack: []
      });
    };

    _this.state = {
      stack: [] // empty stack

    };
    return _this;
  }

  _createClass(RepositoryUploadSnackbar, [{
    key: "render",
    value: function render() {
      var uploadInProgress = this.state.stack.some(function (f) {
        return f.status.response === 'uploading';
      });
      return React.createElement("div", null, React.createElement(Portal, null, React.createElement(Snackbar, {
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'right'
        },
        open: this.state.stack.length > 0,
        ContentProps: {
          'aria-describedby': 'message-id'
        },
        onClose: this.onCloseSnackbar,
        message: this.renderSnackbarMessage(),
        autoHideDuration: uploadInProgress ? null : 5000,
        action: [React.createElement(Icon, {
          key: "close",
          type: uploadInProgress ? 'down' : 'close',
          onClick: this.onCloseSnackbar
        })]
      })));
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(newProps, currentState) {
      var files = newProps.files,
          status = newProps.status;
      if (files == null) return null;

      if (status.response == 'uploading') {
        // when the same component is rerendered, the same file is present in the newProps => filter file
        var newFiles = getNewUploadFiles(files, currentState.stack); // contains files that will be pushed into the stack 

        if (newFiles.length == 0) return null;
        return {
          stack: [].concat(_toConsumableArray(currentState.stack), [{
            files: newFiles,
            status: status
          }])
        };
      } else if (status.response == 'succeeded' || status.response == 'failed') {
        if (currentState.stack.length == 0) return null; // update the corresponding item within stack

        return {
          stack: currentState.stack.map(function (level) {
            if (level.files.every(function (levelFile) {
              return files.includes(levelFile);
            })) {
              return _objectSpread({}, level, {
                status: status
              });
            }

            return level;
          })
        };
      }

      return null;
    }
  }]);

  return RepositoryUploadSnackbar;
}(React.Component);
/**
 * @typedef {object} Props
 * @property {File|File[]} [files] The choosed files.
 * @property {object} [status] The status of the files
 */


export default RepositoryUploadSnackbar;